import axios from 'axios';
import { emitToast, formatApiError } from '../contexts/ToastContext.jsx';

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:5001/api',
  timeout: 15000
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('garmenterp_token') || sessionStorage.getItem('garmenterp_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !error.config?.url?.includes('/auth/')) {
      localStorage.removeItem('garmenterp_token');
      sessionStorage.removeItem('garmenterp_token');
      window.dispatchEvent(new Event('garmenterp:unauthorized'));
    }
    if (!error.config?.skipErrorToast) {
      emitToast(formatApiError(error), 'error');
    }
    return Promise.reject(error);
  }
);
